export const POSITION_LABELS: { [key: string]: string } = {
  GOALKEEPER: "Goal Keeper",
  LEFTBACK: "Left Back",
  RIGHTBACK: "Right Back",
  CENTREBACK: "Centre Back",
  FULLBACK: "Fullback",
  DEFENSIVEMIDFIELD: "Defensive Midfield",
  CENTREMIDFIELD: "Centre Midfield",
  LEFTMIDFIELD: "Left Midfield",
  RIGHTMIDFIELD: "Right Midfield",
  ATTACKINGMIDFIELD: "Attacking Midfield",
  LEFTWING: "Left Wing",
  RIGHTWING: "Right Wing",
  STRIKER: "Striker",
};
